export enum PrimasAllFilterOperator {
    IsEmpty = "Is Empty",
    IsNotEmpty = "Is Not Empty"
}
